<template>
    <div>
        <div class="receipt-header">
            <h2 class="receipt-header-title">Penerimaan QR</h2>
            <div class="receipt-header-saldo">Saldo QR : {{ saldoLabel }}</div>
        </div>


        <qr-receipt-se-table
            v-if="isUserSE"
            class="mt-4"
            @flow-change="handleFlowChange"
        ></qr-receipt-se-table>
        <qr-receipt-from-qtrust
            v-else
            class="mt-4"
        ></qr-receipt-from-qtrust>

    </div>
</template>

<script>
import qrReceiptFromQtrust from './children/qrReceiptFromQtrustTable.vue'
import qrReceiptSeTable from './children/qrReceiptSeTable.vue'
import { FLOW_MD_DEALER, formatCount } from '@/services/qr-issue'
import { fetchReceiptSaldo, pickSaldoForFlow } from '@/services/qr-receipt'

export default {
    metaInfo : {
        title : 'QR Receipt'
    },
    components : {
        qrReceiptFromQtrust,
        qrReceiptSeTable
    },
    data () {
        return {
            saldoQr : null,
            saldoSe : null,
            activeFlow : FLOW_MD_DEALER,
            hasSaldoError : false,
        }
    },
    computed : {
        isUserSE () {
            return this.$store.state.userData.userData.role === 'USER SE'
        },
        saldoLabel () {
            if (this.isUserSE) {
                if (this.hasSaldoError) return '-'
                if (this.saldoSe === null) return 'Loading...'
                return formatCount(pickSaldoForFlow(this.saldoSe, this.activeFlow))
            }
            return this.saldoQr === 0 ? 0 : (this.saldoQr ? this.numberWithCommas(this.saldoQr) : 'Loading...')
        },
    },
    beforeMount () {
        document.getElementById('content').style.background = '#F8F8F8';
    },
    beforeDestroy () {
        document.getElementById('content').style.background = '';
    },
    mounted () {
        this.fetchData();
    },
    methods : {
        handleFlowChange (flow) {
            this.activeFlow = flow
        },
        fetchData() {
            if (this.isUserSE) {
                // Fetched once; switching tabs only re-selects the balance.
                fetchReceiptSaldo(this.$http)
                .then((saldo)=>{
                    this.saldoSe = saldo
                })
                .catch((err)=>{
                    console.log(err)
                    this.hasSaldoError = true
                })
                return
            }
            this.$http.get(`/api/qrs/highlight`)
            .then((resp)=>{
                this.saldoQr = resp.data.data.qty_after
            })
            .catch((err)=>{console.log(err)})
        },
    },
}
</script>

<style>
    .receipt-header {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 8px 16px;
        min-height: 32px;
    }

    .receipt-header-title {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: #2F2F2F;
    }

    .receipt-header-saldo {
        font-size: 12px;
        color: #2F2F2F;
        white-space: nowrap;
    }

    .mpm-button {
        background-color :#F36F21 !important;
        color : white;
        height: 47px;
    }

    .mpm-button-outline {
        background-color :white !important;
        color : #F36F21;
        height: 47px;
    }

    .h-47px {
        height: 47px;
    }
</style>